var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwake4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,145.7c-37.3,0-67.7-30.4-67.7-67.7c0-37.3,30.4-67.7,67.7-67.7c37.3,0,67.7,30.4,67.7,67.7 C145.7,115.3,115.3,145.7,78,145.7z M78,15c-34.7,0-63,28.3-63,63s28.3,63,63,63s63-28.3,63-63S112.7,15,78,15z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.9,
    cy: 68.2,
    rx: 3.4,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 99.2,
    cy: 66.5,
    rx: 3.6,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.7,
    cy: 115.2,
    rx: 17.6,
    ry: 1.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.9,
    cy: 68.5,
    rx: 3.4,
    ry: 3.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwake4);
export default __webpack_public_path__ + "static/media/Awake4.83574c997f9a856c2ea0fc3438fab7bd.svg";
export { ForwardRef as ReactComponent };